import { Context, Effect, Layer, type Scope } from "effect";
import type { ImmutableModelRequest, ImmutableMonacoModel } from "./model.ts";
import type { ImmutableLease, ImmutableRegistryFailure } from "./registry-model.ts";
import { makeImmutableRegistry } from "./registry.ts";
import { ImmutableModelIo } from "./service.ts";
import { ImmutableModelIdentityIo } from "./identity-io.ts";
import { rootedModelIdentity } from "./identity.ts";

export class ImmutableModels extends Context.Service<ImmutableModels, {
  readonly acquire: (request: ImmutableModelRequest) => Effect.Effect<ImmutableLease<ImmutableMonacoModel>, ImmutableRegistryFailure, Scope.Scope>;
  readonly inspect: Effect.Effect<readonly Readonly<{ key: string; references: number }>[]>;
}>()("workerstation/frontend/ImmutableModels") {}

export const ImmutableModelsLive = (owner: Scope.Scope) => Layer.effect(ImmutableModels, Effect.gen(function* () {
  const io = yield* ImmutableModelIo;
  const identityIo = yield* ImmutableModelIdentityIo;
  const rootIdentity = yield* Effect.cached(identityIo.allocate);
  const registry = yield* makeImmutableRegistry<ImmutableMonacoModel>(owner);
  return ImmutableModels.of({
    acquire: Effect.fn("Frontend.ImmutableModels.acquire")((request) => registry.acquire({
      key: request.identity,
      contents: request.contents,
      create: Effect.gen(function* () {
        const identity = yield* rootIdentity;
        return yield* io.acquire({ ...request, identity: rootedModelIdentity(request.identity, identity) });
      }),
      validate: io.validate
    })),
    inspect: registry.inspect
  });
}));
